// NOTE (Robbe): This file contains some slight modifications from the original
// This makes it work as a function so we can
// * Pass data to the function
// * Supply a root element
// We also disable some eslint rules, since I don't want to fix somebody else's mess.

/* eslint-disable no-console */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */

import { Overlay, Feature, Map, View } from "ol";
import { Vector, WebGLTile } from "ol/layer";
import { Vector as VectorSource, Cluster, XYZ } from "ol/source";
import { Attribution } from "ol/control";
import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";
import { GeoJSON } from "ol/format";
import { Select } from "ol/interaction";
import { Polygon, Point } from "ol/geom";
import * as render from "ol/render";
import * as proj from "ol/proj";
import { register } from "ol/proj/proj4";
import proj4 from "proj4";

export function setupSwissTopoMap(rawJsonFile, target = document) {
  // Author
  /**
   *  Author  : https://www.itv.aero, Raphaël Gerth
   *  Contact : info@itv.ch
   *  Version : 1.0
   *  Date    : created : 14.06.2023 / modified : 21.11.2023
   *  Client  : Swisstopo , Bundesamt für Landestopografie, Seftigenstrasse 264, 3084 Bern, Schweiz
   *  */

  // OpenLayers License :
  /*
   * OpenLayers - JavaScript library for interactive maps
   * https://openlayers.org/
   *
   * Copyright (c) 2006-2023 OpenLayers Contributors
   * Published under the 2-clause BSD license.
   * See https://github.com/openlayers/openlayers/blob/main/LICENSE.md for the full text of the license.
   */

  // CONST
  /////////////////////////////////////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  // The list of Parelement member
  const VoteData = rawJsonFile.voteData;
  // The Point of iterest of the votation
  const VotingInterestData = rawJsonFile.voteInterest;
  // Title information
  const VoteTitle = rawJsonFile.voteTitle;

  // Map sytling, backround
  const BasicMapStyle = {
    opacity: 1.0,
    style: {
      gamma: 1,
    },
  };
  // Map sytling, Lakes
  const LakesStyle = {
    opacity: 1,
    style: {
      gamma: 1,
    },
  };
  // Map sytling, Kanton
  const CantonStyle = {
    opacity: 1,
    style: {
      saturation: 0.01,
      gamma: 0.1,
    },
  };

  // Popup elements
  const container = target.getElementById("popup");
  const content = target.getElementById("popup-content");
  const closer = target.getElementById("popup-closer");

  //Generates WMS layers
  const BasicMap = CreateLayer(
    BasicMapStyle,
    "ch.swisstopo.leichte-basiskarte_reliefschattierung",
    "current",
    "png",
  );
  const Lakes = CreateLayer(LakesStyle, "ch.bafu.vec25-seen", "current", "png");
  const Canton = CreateLayer(
    CantonStyle,
    "ch.swisstopo.swissboundaries3d-kanton-flaeche.fill",
    "current",
    "png",
  );

  //Generate the Attribution component (copyright)
  const attribution = new Attribution({
    collapsible: false, // You can customize this based on your needs
    label: "test",
  });

  // PROJ4 DEFS
  /////////////////////////////////////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  proj4.defs(
    "EPSG:2056",
    "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 +k_0=1" +
      " +x_0=2600000 +y_0=1200000 +ellps=bessel +towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs",
  );
  proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs +type=crs");
  register(proj4);
  // FUNCTIONS
  /////////////////////////////////////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  /**
   * Updates HTML elements with data properties, such as title, information, and statistique.
   *
   * @param {Object} data - Data object with properties to update HTML elements.
   * @param {string} data.title - Title to be displayed in the 'titleData' element.
   * @param {string} data.information - Information to be displayed in the 'informationData' element.
   * @param {string} data.statistique - Statistic data to be displayed in the 'statistiqueData' element.
   */
  function updateTitle(data) {
    target.getElementById("titleData").textContent = data.title;
    target.getElementById("informationData").textContent = data.information;
    target.getElementById("statistiqueData").textContent = data.statistique;
  }

  /**
   * Divides a string into lines of a specified width, preserving word integrity by breaking at spaces or hyphens.
   *
   * @param {string} str - Input string to be divided.
   * @param {number} width - Maximum width of each line.
   * @param {string} spaceReplacer - String used to replace spaces when breaking lines.
   * @returns {string} - Formatted string with line breaks.
   */
  function stringDivider(str, width, spaceReplacer) {
    if (str.length > width) {
      let p = width;
      while (p > 0 && str[p] != " " && str[p] != "-") {
        p--;
      }
      if (p > 0) {
        let left;
        if (str.substring(p, p + 1) == "-") {
          left = str.substring(0, p + 1);
        } else {
          left = str.substring(0, p);
        }
        const right = str.substring(p + 1);
        return (
          left + spaceReplacer + stringDivider(right, width, spaceReplacer)
        );
      }
    }
    return str;
  }

  /**
   * Function to define a simple red OpenLayers style for individual map features.
   *
   * @param {Feature} feature - The OpenLayers feature to be styled.
   * @returns {Style} - The OpenLayers style object for the feature.
   */
  function simpleRedStyle(feature) {
    return new Style({
      // Define the image style for the feature.
      stroke: new Stroke({
        color: "black",
        width: 2,
      }),
      fill: new Fill({
        color: "rgba(0, 0, 0, 0.2)",
      }),
      image: new Circle({
        radius: 6,
        fill: new Fill({
          color: "black",
        }),
        stroke: new Stroke({
          color: "white",
          width: 2,
        }),
      }),
      // Define the texte style for the feature.
      text: new Text({
        text:
          map.getView().getZoom() <= 11
            ? ""
            : stringDivider(feature.get("info"), 5, "\n"), // The name attribute of the feature
        justify: "left",
        font: "14px Arial",
        fill: new Fill({
          color: "black",
        }),
        offsetX: 10,
        textAlign: "left",
        backgroundFill: new Fill({
          color: "white",
        }),
        padding: [2, 2, 2, 2],
      }),
    });
  }
  /**
   * Function to define a custom OpenLayers style for individual map features.
   *
   * @param {Feature} feature - The OpenLayers feature to be styled.
   * @returns {Style} - The OpenLayers style object for the feature.
   */
  function IndividualFeatureStyle(feature) {
    return new Style({
      image: new Circle({
        radius: 6,
        fill: new Fill({
          color:
            feature.get("vote") === "Oui" || feature.get("vote") === "Ja"
              ? "blue"
              : feature.get("vote") === "Non" || feature.get("vote") === "Nein"
                ? "red"
                : "#a88332",
        }),
        stroke: new Stroke({
          color: "white",
          width: 2,
        }),
      }),
      text: new Text({
        text:
          map.getView().getZoom() <= 11
            ? ""
            : map.getView().getZoom() <= 12
              ? feature.get("info").party_abbreviation
              : feature.get("info").party_abbreviation +
                "\n" +
                feature.get("name") +
                " " +
                feature.get("surname"),
        font: "12px Arial",
        fill: new Fill({
          color: "black",
        }),
        textBaseline: "center",
        textAlign: "left",
        padding: [5, 5, 5, 5],
        offsetX: 10,
      }),
    });
  }
  /**
   * Create an OpenLayers style for a point feature.
   *
   * @param {number} voteValue - The vote value to be displayed on the point.
   * @param {string} fillColor - The fill color of the shape.
   * @param {string} strokeColor - The stroke color of the shape.
   * @returns {Style} - The OpenLayers style object.
   */
  function createCustomStyle(voteValue, displacement, fillColor, strokeColor) {
    let scale = 1;
    const scaleFunction = function (coordinate) {
      return [coordinate[0] * scale, coordinate[1] * scale];
    };
    const symbol = [
      [0, 0],
      [2, 2],
      [2, voteValue * 5 + 2],
      [17, voteValue * 5 + 2],
      [17, 2],
      [2, 2],
      [0, 0],
    ];
    const canvas = document.createElement("canvas");
    const vectorContext = render.toContext(canvas.getContext("2d"), {
      size: [120, 1000],
      pixelRatio: 1,
    });
    vectorContext.setStyle(
      new Style({
        stroke: new Stroke({ color: "white", width: 2 }),
        fill: new Fill({ color: fillColor }),
      }),
    );
    vectorContext.drawGeometry(new Polygon([symbol.map(scaleFunction)]));
    return new Style({
      image: new Icon({
        img: canvas,
        imgSize: [1000, 1000],
        displacement: [-displacement + 489, -500],
        rotation: Math.PI,
      }),
      text: new Text({
        text: voteValue.toString(),
        font: "12px Arial",
        fill: new Fill({
          color: "black",
        }),
        textBaseline: "center",
        textAlign: "center",
        offsetY: 10,
        offsetX: displacement,
      }),
    });
  }

  /**
   * Transforms a list of coordinates from EPSG 2056 to EPSG 4326 projection.
   *
   * @param {Array} list - A list containing items with coordinates to be transformed.
   * @param {string} geometry - The type of geometry ('point' or 'linestring') to specify how coordinates should be transformed.
   * @returns {Array} A list of transformed coordinates and other item content.
   */
  function CoordinatesTransform(list, geoemtry) {
    // Output list
    let featureListe = [];
    // Loop over list
    switch (geoemtry) {
      case "customExcelFormat":
        for (let item of list) {
          // Transformes item.coordinates from EPSG:2056 to EPSG:4326
          item.coordinates = proj.transform(
            item.coordinates,
            "EPSG:2056",
            "EPSG:3857",
          );
          // Append to list
          featureListe.push({ ...item });
        }
        return featureListe;
      case "GEOJSON":
        for (let item of list.features) {
          switch (item.geometry.type) {
            case "Point":
              if (
                item.geometry.coordinates[0] >= 2 &&
                item.geometry.coordinates[0] <= 12 &&
                item.geometry.coordinates[1] >= 40 &&
                item.geometry.coordinates[1] <= 50
              ) {
                item.geometry.coordinates = proj.transform(
                  item.geometry.coordinates,
                  "EPSG:4326",
                  "EPSG:3857",
                );
              } else {
                item.geometry.coordinates = proj.transform(
                  item.geometry.coordinates,
                  "EPSG:2056",
                  "EPSG:3857",
                );
              }
              featureListe.push({ ...item });
              break;
            case "LineString":
              for (let i = 0; i < item.geometry.coordinates.length; i++) {
                if (
                  item.geometry.coordinates[i][0] >= 2 &&
                  item.geometry.coordinates[i][0] <= 12 &&
                  item.geometry.coordinates[i][1] >= 40 &&
                  item.geometry.coordinates[i][1] <= 50
                ) {
                  item.geometry.coordinates[i] = proj.transform(
                    item.geometry.coordinates[i],
                    "EPSG:4326",
                    "EPSG:3857",
                  );
                } else {
                  item.geometry.coordinates[i] = proj.transform(
                    item.geometry.coordinates[i],
                    "EPSG:2056",
                    "EPSG:3857",
                  );
                }
              }
              featureListe.push({ ...item });
              break;
            case "Polygon":
              for (let i = 0; i < item.geometry.coordinates.length; i++) {
                for (let j = 0; j < item.geometry.coordinates[i].length; j++) {
                  if (
                    item.geometry.coordinates[i][j][0] >= 2 &&
                    item.geometry.coordinates[i][j][0] <= 12 &&
                    item.geometry.coordinates[i][j][1] >= 40 &&
                    item.geometry.coordinates[i][j][1] <= 50
                  ) {
                    item.geometry.coordinates[i][j] = proj.transform(
                      item.geometry.coordinates[i][j],
                      "EPSG:4326",
                      "EPSG:3857",
                    );
                  } else {
                    item.geometry.coordinates[i][j] = proj.transform(
                      item.geometry.coordinates[i][j],
                      "EPSG:2056",
                      "EPSG:3857",
                    );
                  }
                }
              }
              featureListe.push({ ...item });
              break;
            default:
              console.error("Unsupported GEOJSON type: " + item.geometry.type);
          }
        }
        list.features = featureListe;
        return list;
      default:
        console.error("Unsupported geometry type: " + geoemtry);
    }
  }
  /**
   * Create an OpenLayers layer with features from a list of data for a specified geometry type.
   *
   * @param {Array} list - A list of data items, each containing coordinates for the specified geometry.
   * @param {string} geometry - The type of geometry ('linestring' in this case) for the features.
   * @param {Style} style - The style to apply to the features on the layer.
   * @returns {Vector} An OpenLayers vector layer with features created from the data.
   */
  function simpleData2Layer(list, style) {
    // Create a vector source for the features
    let source = new VectorSource({
      features: new GeoJSON().readFeatures(list),
    });

    // Create a vector layer with the provided source and style
    let layer = new Vector({
      source: source,
      style: style,
    });
    return layer;
  }
  /**
   * Converts a list of data to an OpenLayers vector layer with clustering and custom styling.
   *
   * @param {Array} list - An array of objects representing data points.
   * @returns {Vector} An OpenLayers vector layer with clustering and custom styling.
   */
  function data2Layer(list) {
    // Create an array to store features.
    let features = {};
    // Create an array to store the layers
    let layers = [];
    // Iterate through the input list and create features for each data point.
    for (let item of list) {
      if (!features[item.canton]) {
        features[item.canton] = [];
      }

      features[item.canton].push(
        new Feature({
          name: item.name,
          surname: item.surname,
          info: item.info,
          vote: item.vote,
          canton: item.canton,
          geometry: new Point(item.coordinates),
        }),
      );
    }
    // Create a vector source with the features.
    for (let canton in features) {
      let source = new VectorSource({
        features: features[canton],
      });
      let cluster = new Cluster({
        source: source,
        // Distance in pixels within which features will be clustered together.
        distance: 200,
      });
      let layer = new Vector({
        source: cluster,
        style: function (feature) {
          var features = feature.get("features");
          var size = features.length;
          var vote = [0, 0, 0]; //[Yes, No, Else]
          // Calculate vote counts within the cluster.
          for (feature of features) {
            switch (feature.values_.vote) {
              case "Oui":
                vote[0] += 1;
                break;
              case "Non":
                vote[1] += 1;
                break;
              case "Ja":
                vote[0] += 1;
                break;
              case "Nein":
                vote[1] += 1;
                break;
              default:
                vote[2] += 1;
            }
          }
          // Custom styling for clusters.
          if (size > 1) {
            // Define styling for cluster with 'Else' votes.
            var style1 = createCustomStyle(vote[2], 0, "#a88332", "#a88332");
            // Define styling for cluster with 'Oui' votes.
            var style2 = createCustomStyle(vote[0], -15, "blue", "blue");
            // Define styling for cluster with 'Non' votes.
            var style3 = createCustomStyle(vote[1], 15, "red", "red");
            //Return a style for Cluster with the count of [Yes, No, Else]
            return [style1, style2, style3];
          } else if (size === 1) {
            // Custom styling for individual features.
            var individualFeature = features[0];
            var individualStyle = IndividualFeatureStyle(individualFeature);
            return individualStyle;
          } else {
            return null;
          }
        },
      });
      layers.push(layer);
    }
    return layers;
  }
  /**
   * Creates an OpenLayers WebGLTile layer with the specified style configuration and data source.
   *
   * @param {Object} styleConfig - An object containing style configuration for the layer.
   * @param {string} layerName - The name of the layer for the data source.
   * @param {string} timeStamp - The timestamp for the data source.
   * @param {string} extension - The file extension of the data source.
   * @returns {WebGLTile} An OpenLayers WebGLTile layer configured with the provided style and data source.
   */
  function CreateLayer(styleConfig, layerName, timeStamp, extension) {
    return new WebGLTile({
      style: styleConfig["style"],
      opacity: styleConfig["opacity"],
      preload: 0.0,
      source: new XYZ({
        url:
          "https://wmts10.geo.admin.ch/1.0.0/" +
          layerName +
          "/default/" +
          timeStamp +
          "/3857/{z}/{x}/{y}." +
          extension,
        attributions: [
          '© Development : <a href="https://www.itv.aero">ITV Consult</a>, Data : swisstopo, <a href="https://www.bafu.admin.ch/bafu/de/home.html">BAFU</a>',
        ],
      }),
    });
  }

  var overlay = new Overlay({
    element: container,
    autoPan: {
      animation: {
        duration: 250,
      },
    },
  });

  closer.onclick = function () {
    overlay.setPosition(undefined);
    closer.blur();
    return false;
  };
  /**
   * Creates and returns an OpenLayers map with the specified layers and view configuration.
   *
   * @param {string} target - The ID of the HTML element where the map should be rendered.
   * @param {Array<ol.layer.Base>} layers - An array of OpenLayers layers to be added to the map.
   * @param {number} initialZoom - The initial zoom level of the map.
   * @param {number} maxZoom - The maximum allowed zoom level.
   * @param {number} minZoom - The minimum allowed zoom level.
   * @returns {Map} - The OpenLayers map object.
   */
  function createOpenLayersMap(target, layers) {
    // Create the attribution control
    const attributionControl = new Attribution({
      collapsible: false, // This prevents collapsing
    });

    return new Map({
      controls: [attributionControl],
      target: target,
      layers: layers,
      view: new View({
        //Where the intial view Points at
        center: proj.fromLonLat([8.2275, 46.8182]),
        //What the intial zoom is
        zoom: 8.5,
        //What the maximal zoom is
        maxZoom: 16,
        //What the minimal zoom is
        minZoom: 8,
      }),
    });
  }
  /**
   * Event handler for a selection event on a map feature.
   *
   * @param {object} event - The selection event object.
   * @param {Element} content - The HTML element where the popup content will be displayed.
   * @param {Overlay} overlay - The OpenLayers overlay to display the popup.
   */
  const handleSelectionEvent = (event, content, overlay) => {
    //When a Single Point is selected
    if (event.selected[0].values_.features.length == 1) {
      var selectedFeature = event.selected[0];
      if (selectedFeature) {
        var coordinate = selectedFeature.getGeometry().getCoordinates();
        var popupContent =
          "<h4>" +
          selectedFeature.get("features")[0].get("name") +
          " " +
          selectedFeature.get("features")[0].get("surname") +
          "</h4>";
        popupContent +=
          "<p>" +
          "Party  : " +
          selectedFeature.get("features")[0].get("info").party_abbreviation +
          ", " +
          selectedFeature.get("features")[0].get("info").party_name +
          "</p>";
        popupContent +=
          "<p>" +
          "Kanton : " +
          selectedFeature.get("features")[0].get("canton") +
          "</p>";
        popupContent +=
          "<p>" +
          "Stimme : " +
          selectedFeature.get("features")[0].get("vote") +
          "</p>";
        content.innerHTML = popupContent;
        overlay.setPosition(coordinate);
      }
    }
    //When a Cluster is selected
    else {
      var selectedFeatures = event.selected[0];
      if (selectedFeatures) {
        var coordinate = selectedFeatures.getGeometry().getCoordinates();
        var popupContent = "<table>";
        let entry = "<tr><th>" + "Name" + " " + "Surname" + "</th>";
        entry += "<th>" + "info" + "</th>";
        entry += "<th>" + "vote" + "</th></tr>";
        popupContent += entry;
        for (selectedFeature of selectedFeatures.values_.features) {
          let entry =
            "<tr><td>" +
            selectedFeature.get("name") +
            " " +
            selectedFeature.get("surname") +
            "</td>";
          entry +=
            "<td>" + selectedFeature.get("info").party_abbreviation + "</td>";
          entry += "<td>" + selectedFeature.get("vote") + "</td></tr>";
          popupContent += entry;
        }
        popupContent += "</table";
        content.innerHTML = popupContent;
        overlay.setPosition(coordinate);
      }
    }
  };
  // CODE
  /////////////////////////////////////////////////////////////\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\
  // Generated the title
  updateTitle(VoteTitle);
  // Generates the map
  var map = createOpenLayersMap(target.querySelector("#map"), [
    BasicMap,
    Lakes,
    Canton,
  ]);
  // Transformes the coordinates
  var TransformedVotingInterestData = CoordinatesTransform(
    VotingInterestData,
    "GEOJSON",
  );
  var TransformedVoteData = CoordinatesTransform(VoteData, "customExcelFormat");
  // Generates the vector layers
  var LayerVoteData = data2Layer(TransformedVoteData);

  var LayerVotingInterestData = simpleData2Layer(
    TransformedVotingInterestData,
    simpleRedStyle,
  );
  // Add overlay ot the map
  map.addOverlay(overlay);
  // Add layerData ot the map
  for (let layer of LayerVoteData) {
    map.addLayer(layer);
  }

  map.addLayer(LayerVotingInterestData);
  // Initialize the select Interaction (Must be done after map, and the layer it uses)
  var select = new Select({
    layers: LayerVoteData,
    style: null,
  });
  // Add select to the map
  map.addInteraction(select);

  // Add a listener to the select interaction to display the popup
  select.on("select", (event) => handleSelectionEvent(event, content, overlay));
}
